// import React, { useEffect, useState } from "react";
// import { Outlet } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";
// import ServitorSiteLayout from "./ServitorSiteLayout";

// const ServitorSiteLayoutWrapper = () => {
//   const [servitor, setServitor] = useState(null);
//   const [loading, setLoading] = useState(true);

//   // Logout function
//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     window.location.href = "/login";
//   };

//   // Helper function to get the CSS class for status
//   const getStatusClass = (status) => {
//     switch (status) {
//       case "Pending":
//         return "status-pending";
//       case "Approved":
//         return "status-approved";
//       case "Blocked":
//         return "status-blocked";
//       default:
//         return "";
//     }
//   };

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       // Redirect if no token
//       window.location.href = "/login";
//       return;
//     }
//     const decodedToken = jwtDecode(token);
//     if (
//       decodedToken.role === "servitor" &&
//       decodedToken.Id.startsWith("servitor-")
//     ) {
//       const servitorId = decodedToken.Id.split("-")[1];
//       fetch(`http://localhost:4001/servitors/${servitorId}`)
//         .then((res) => res.json())
//         .then((data) => {
//           // console.log("servitor data",data);
//           setServitor(data);
//           setLoading(false);
//         })
//         .catch((err) => {
//           console.error("Error fetching servitor:", err);
//           setLoading(false);
//         });
//     } else {
//       console.error("Unauthorized role access");
//       setLoading(false);
//     }
//   }, []);

//   if (loading) return <p>Loading...</p>;
//   if (!servitor) return <p>No servitor data found.</p>;

//   return (
//     <ServitorSiteLayout
//       servitor={servitor}
//       handleLogout={handleLogout}
//       getStatusClass={getStatusClass}
//     >
//       {/* Pass the common context to child routes */}
//       <Outlet context={{ servitor, getStatusClass }} />
//     </ServitorSiteLayout>
//   );
// };

// export default ServitorSiteLayoutWrapper;


// ***** Upper code All is okaye (25-6-25) ***** //






// ***** Translate added EN BN (25-6-25) ***** //

// import React, { useEffect, useState, useCallback } from "react";
// import { Outlet } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";
// import ServitorSiteLayout from "./ServitorSiteLayout";
// import { useTranslation } from "react-i18next";
// import { URL } from "../../../config";
// import Loader from "../../../Components/LoaderSpin/Loader";

// const ServitorSiteLayoutWrapper = () => {
//   const { t } = useTranslation("servitor");
//   const [servitor, setServitor] = useState(null);
//   const [loading, setLoading] = useState(true);

//   // Logout function
//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     window.location.href = "/login";
//   };

//   // Helper function to get the CSS class for status
//   const getStatusClass = (status) => {
//     switch (status) {
//       case "Pending":
//         return "status-pending";
//       case "Approved":
//         return "status-approved";
//       case "Blocked":
//         return "status-blocked";
//       default:
//         return "";
//     }
//   };

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       // Redirect if no token
//       window.location.href = "/login";
//       return;
//     }
//     const decodedToken = jwtDecode(token);
//     if (
//       decodedToken.role === "servitor" &&
//       decodedToken.Id.startsWith("servitor-")
//     ) {
//       const servitorId = decodedToken.Id.split("-")[1];
//       fetch(`${URL}/servitors/${servitorId}`)
//         .then((res) => res.json())
//         .then((data) => {
//           // console.log("servitor data",data);
//           setServitor(data);
//           setLoading(false);
//         })
//         .catch((err) => {
//           console.error("Error fetching servitor:", err);
//           setLoading(false);
//         });
//     } else {
//       console.error("Unauthorized role access");
//       setLoading(false);
//     }
//   }, []);

//   // if (loading) return <p>Loading...</p>;
//   // if (!servitor) return <p>No servitor data found.</p>;

//   // if (loading) return <p>{t("common.loading")}</p>;

//   // Refresh or refetch Servitor data
//   const refreshServitor = useCallback(async () => {
//     const token = localStorage.getItem("token");
//     if (!token) {
//       window.location.href = "/login";
//       return;
//     }

//     try {
//       const decodedToken = jwtDecode(token);
//       if (
//         decodedToken.role === "servitor" &&
//         decodedToken.Id.startsWith("servitor-")
//       ) {
//         const servitorId = decodedToken.Id.split("-")[1];
//         const res = await fetch(`${URL}/servitors/${servitorId}`);
//         const data = await res.json();
//         setServitor(data);
//       } else {
//         console.error("Unauthorized role access");
//       }
//     } catch (err) {
//       console.error("Error fetching servitor:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     refreshServitor();
//   }, [refreshServitor]);

//   if (loading) {
//     return <Loader show={loading} />;
//   }

//   if (!servitor) return <p>{t("common.noData")}</p>;

//   return (
//     <ServitorSiteLayout
//       servitor={servitor}
//       handleLogout={handleLogout}
//       getStatusClass={getStatusClass}
//     >
//       {/* Pass the common context to child routes */}
//       <Outlet context={{ servitor, getStatusClass }} />
//     </ServitorSiteLayout>
//   );
// };

// export default ServitorSiteLayoutWrapper;









import React, { useEffect, useState, useCallback } from "react";
import { Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import ServitorSiteLayout from "./ServitorSiteLayout";
import { useTranslation } from "react-i18next";
import { URL } from "../../../config";
import Loader from "../../../Components/LoaderSpin/Loader";
import SEO from "../../../Components/SEO/SEO";

const ServitorSiteLayoutWrapper = () => {
  const { t } = useTranslation("servitor");
  const [servitor, setServitor] = useState(null);
  const [loading, setLoading] = useState(true);

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("adminToken");
    localStorage.removeItem("role");
    sessionStorage.clear();
    window.location.href = "/login";
  };

  // Helper function to get the CSS class for status
  const getStatusClass = (status) => {
    switch (status) {
      case "Pending":
        return "status-pending";
      case "Approved":
        return "status-approved";
      case "Blocked":
        return "status-blocked";
      default:
        return "";
    }
  };

  // ✅ Single, reusable fetch used everywhere
  const refreshServitor = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      window.location.href = "/login";
      return;
    }

    try {
      const decodedToken = jwtDecode(token);
      if (
        decodedToken.role === "servitor" &&
        decodedToken.Id.startsWith("servitor-")
      ) {
        const servitorId = decodedToken.Id.split("-")[1];
        const res = await fetch(`${URL}/servitors/${servitorId}`);
        const data = await res.json();
        setServitor(data);
      } else {
        console.error("Unauthorized role access");
      }
    } catch (err) {
      console.error("Error fetching servitor:", err);
    }
  }, []);

  // ✅ Initial load uses refreshServitor and controls `loading`
  useEffect(() => {
    const init = async () => {
      setLoading(true);
      await refreshServitor();
      setLoading(false);
    };
    init();
  }, [refreshServitor]);

  if (loading) {
    return <Loader show={loading} />;
  }

  if (!servitor) return <p>{t("common.noData")}</p>;

  return (
    <>
    <SEO title="Servitor Dashboard | HelpNao" path="/servitor" noindex />
    <ServitorSiteLayout
      servitor={servitor}
      handleLogout={handleLogout}
      getStatusClass={getStatusClass}
      refreshServitor={refreshServitor}
    >
      {/* ✅ Pass refreshServitor in context so children can re-fetch after actions */}
      <Outlet
        context={{
          servitor,
          getStatusClass,
          refreshServitor,
        }}
      />
    </ServitorSiteLayout>
    </>
  );
};

export default ServitorSiteLayoutWrapper;
